var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MainContent,{attrs:{"title":"Crear categoría"}},[_c(_setup.Card,[_c(_setup.CategoriaForm,{attrs:{"initial-data":null,"submit-label":"Guardar","loading":_setup.loading},on:{"submit":_setup.handleSubmit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }